"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SearchResultsWrapper = void 0;
var design_language_1 = require("@doordash/design-language");
var styled_components_1 = __importDefault(require("styled-components"));
exports.SearchResultsWrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  width: 231px;\n  position: absolute;\n  z-index: 2;\n  margin-top: 0 !important;\n  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);\n  max-height: ", "px;\n  overflow-y: scroll;\n"], ["\n  border: 1px solid ", ";\n  width: 231px;\n  position: absolute;\n  z-index: 2;\n  margin-top: 0 !important;\n  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);\n  max-height: ", "px;\n  overflow-y: scroll;\n"])), design_language_1.Colors.SystemGrey10, design_language_1.Spacing.XxxLarge * 5);
var templateObject_1;
